<template>
    <div class="presentacion">
        <div class="col-lg-12">
            <h5 class="titulo-video ">Tu solución a un solo click</h5>

            <div class="div-video margin-card">
                <b-embed
                    type="iframe"
                    aspect="16by9"
                    src="https://www.youtube.com/embed/kY0KkhO1ZQ4"
                    allowfullscreen
                ></b-embed>
            </div>
            
            <!-- <div class="div-video col-lg-12">
                <iframe 
                    width="50%"
                    height="80%"
                    src="https://www.youtube.com/embed/kY0KkhO1ZQ4" 
                    title="YouTube video player" 
                    frameborder="0" 
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen
                >
                </iframe>
            </div> -->
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            
        }
    },
    methods: {
        
    },
}
</script>
<style scoped>
    .titulo-video {
        font-family: Muli-Extrabold;
        font-style: normal;
        font-size: 45px;
        line-height: 80px;
        align-items: center;
        text-align: center;
        letter-spacing: 0.2px;
        color: #1E2245;
        
    }

    @media only screen and (max-width: 600px) {
        .margin-card{
            margin-left: 10px;
            margin-right: 10px;
            margin-top: 20px;
            margin-bottom: 20px;
        }
        .div-video{
            height: 50vh;
        }
    }
    @media only screen and (min-width: 601px) and (max-width: 960px) {
        .margin-card{
            margin-left: 50px;
            margin-right: 50px;
            margin-top: 50px;
            margin-bottom: 50px;
        }
        .div-video{
            height: 70vh;
        }
    }
    @media only screen and (min-width: 961px) and (max-width: 1264px) {
        .margin-card{
            margin-left: 80px;
            margin-right: 80px;
            margin-top: 60px;
            margin-bottom: 60px;
        }
        .div-video{
            height: 80vh;
        }
    }
    @media only screen and (min-width: 1265px) and (max-width: 1904px) {
        .margin-card{
            margin-left: 150px;
            margin-right: 150px;
            margin-top: 90px;
            margin-bottom: 90px;
        }
        .div-video{
            height: 80vh;
        }
    }
    @media only screen and (min-width: 1905px) {
        .margin-card{
            margin-left: 250px;
            margin-right: 250px;
            margin-top: 100px;
            margin-bottom: 100px;
        }
        .div-video{
            height: 80vh;
        }
    }
</style>